import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/elearning-packages',
        component: () => import('@/pages/elearning/ElearningPackagesIndex.vue'),
        props: true,
        children: [
            {
                name: 'elearning-packages-index',
                path: '',
                component: () => import('@/components/elearning/ElearningPackagesView.vue'),
                meta: {
                    title: 'eLearning Packages',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'elearning packages' },
                },
                props: true,
                beforeEnter: FeatureMiddleware('ELEARNING_PACKAGES'),
            },
            {
                name: 'elearning-packages-show',
                path: ':id',
                component: () => import('@/components/elearning/ElearningPackageDetailView.vue'),
                meta: {
                    title: 'eLearning Packages',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view all', subject: 'elearning packages' },
                },
                props: route => ({
                    packageId: route.params.id,
                }),
                beforeEnter: FeatureMiddleware('ELEARNING_PACKAGES'),
            },
        ],
    },
];
